/**
 * Over ons beliefs compare — toggle don’t / do panels with staggered reveal.
 */
(() => {
  const roots = document.querySelectorAll('[data-sknly-beliefs-compare]');

  for (const root of roots) {
    if (!(root instanceof HTMLElement)) continue;
    if (root.dataset.beliefsReady === 'true') continue;
    root.dataset.beliefsReady = 'true';

    const tabs = root.querySelectorAll('[data-beliefs-tab]');
    const panels = root.querySelectorAll('[data-beliefs-panel]');
    const swap = root.querySelector('[data-beliefs-swap]');

    const setMode = (mode) => {
      for (const tab of tabs) {
        if (!(tab instanceof HTMLElement)) continue;
        const isActive = tab.dataset.beliefsTab === mode;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      }

      for (const panel of panels) {
        if (!(panel instanceof HTMLElement)) continue;
        const isActive = panel.dataset.beliefsPanel === mode;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
        panel.classList.toggle('is-entering', isActive);
      }

      if (swap instanceof HTMLElement) {
        swap.classList.toggle('is-flipped', mode === 'do');
      }
    };

    for (const tab of tabs) {
      tab.addEventListener('click', () => {
        const mode = tab instanceof HTMLElement ? tab.dataset.beliefsTab : null;
        if (mode === 'dont' || mode === 'do') setMode(mode);
      });
    }

    if (swap instanceof HTMLElement) {
      swap.addEventListener('click', () => {
        const active = root.querySelector('[data-beliefs-tab].is-active');
        const current = active instanceof HTMLElement ? active.dataset.beliefsTab : 'dont';
        setMode(current === 'dont' ? 'do' : 'dont');
      });
    }

    setMode('dont');
  }
})();
